// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { connect } from 'react-redux';
import { toggleModal } from '../../storage/actions/modalsActions';
import onSubmit from '../../utils/reduxForm/onSubmit/addFundsToDwollaBalanceBySuperAdmin';
import AddFundsToDwollaBalanceBySuperAdminReduxForm from '../layout/reduxForm/AddFundsToDwollaBalanceBySuperAdmin';

const AddFundsToDwollaBalance = ({ modalState, toggleModal }) => {
  const closeModal = () => {
    toggleModal(false, 'addFundsToDwollaBalance');
  };

  if (!modalState.isOpen) {
    return null;
  }

  return (
    <div className="popup_block dashboard-modal dashboard-modal--funds showed">
      <div className="popup_container">
        <div className="popup_head">
          <div className="popup_title">Add Funds</div>
          <button type="button" className="close_btn" aria-label="close" onClick={closeModal}>
            ×
          </button>
        </div>
        <AddFundsToDwollaBalanceBySuperAdminReduxForm
          onSubmit={onSubmit}
          closeModal={closeModal}
        />
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  toggleModal,
};

const mapStateToProps = (state) => ({
  modalState: state.modalState.addFundsToDwollaBalance,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddFundsToDwollaBalance);
